import { supabase } from '../../../integrations/supabase/client';

export interface UploadResult {
  url: string;
  path: string;
  fileName: string;
}

export const storageService = {
  /**
   * Sube un archivo al bucket correspondiente según su tipo
   */
  async uploadFile(
    file: File,
    type: 'image' | 'audio' | 'video' | 'document'
  ): Promise<UploadResult> {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Usuario no autenticado');

    // Determinar bucket
    const bucketMap = {
      image: 'training_images',
      audio: 'Voces',
      video: 'videos',
      document: 'documentos'
    };
    const bucket = bucketMap[type];

    // Generar path único: userId/timestamp_filename
    const timestamp = Date.now();
    const sanitizedName = file.name.replace(/[^a-zA-Z0-9.-]/g, '_');
    const filePath = `${user.id}/${timestamp}_${sanitizedName}`;

    // Subir archivo
    const { data, error } = await supabase.storage
      .from(bucket)
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (error) {
      console.error('Error subiendo archivo:', error);
      throw error;
    }

    // Obtener URL pública
    const { data: urlData } = supabase.storage
      .from(bucket)
      .getPublicUrl(data.path);

    return {
      url: urlData.publicUrl,
      path: data.path,
      fileName: file.name
    };
  },

  /**
   * Elimina un archivo del storage
   */
  async deleteFile(bucket: string, path: string): Promise<void> {
    const { error } = await supabase.storage
      .from(bucket)
      .remove([path]);

    if (error) {
      console.error('Error eliminando archivo:', error);
      throw error;
    }
  },

  /**
   * Extrae el bucket y path desde una URL pública de Supabase
   */
  parseStorageUrl(url: string): { bucket: string; path: string } | null {
    const regex = /storage\/v1\/object\/public\/([^/]+)\/(.+)$/;
    const match = url.match(regex);

    if (!match) return null;

    return {
      bucket: match[1],
      path: decodeURIComponent(match[2])
    };
  }
};
